var map = {
	"./announcement.png": "d6d5",
	"./certification-user.png": "1618",
	"./faq.png": "b985",
	"./list-switch.png": "0adc",
	"./marketing.png": "c1c7",
	"./publish-plan.png": "2c39",
	"./voice-examine.png": "b28c",
	"./voice-manage.png": "bbed",
	"./voice.png": "1370",
	"./乘客管理.png": "41e8",
	"./区域管理.png": "a186",
	"./反馈管理.png": "5dd9",
	"./商城管理.png": "0b55",
	"./商户管理.png": "cf25",
	"./图标管理.png": "7a29",
	"./基础信息.png": "7b5d",
	"./字体管理.png": "a6c9",
	"./官方模版管理.png": "8f22",
	"./客户端版本管理.png": "94e0",
	"./帮助中心管理.png": "1950",
	"./数据管理.png": "e79e",
	"./权限管理.png": "f010",
	"./用户管理.png": "d31f",
	"./站点管理.png": "40df",
	"./行业管理.png": "6d71",
	"./设置.png": "d16f",
	"./轮播图管理.png": "77e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d965";